import { useApi } from 'hooks';
import api from 'lib/quoteBind/quoteBind.api';

async function getDraftList(params, token) {
  const response = await api(token).get('risks/drafts', {
    params: {
      page: params.page || 1,
      size: params.size || 12,
      orderBy: params.orderBy || 'id',
      direction: params.direction || 'desc',
      ...params,
    },
  });
  return response.data;
}

export function useGetDraftRiskList(queryKey, params, options) {
  return useApi([queryKey, { ...params }], async (params, token) => await getDraftList(params, token), {
    cacheTime: 1000 * 60 * 10,
    ...options,
  });
}
